import React from 'react'

import { SIconSpan } from '../../../common/styles/Icons'

interface IDownloadIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

const DownloadIcon = ({
    fill = 'currentColor',
    size = 14,
    title,
    id = 'download-icon',
}: IDownloadIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_3375_9880)">
                    <path d="M11.8 2H10.2V11H11.8V2Z" fill={fill} />
                    <path
                        d="M11 15.9092C11.856 15.9092 12.656 15.5656 13.264 14.952L18.728 9.36377H16.456L12.128 13.7901C11.832 14.101 11.424 14.2729 11 14.2729C10.576 14.2729 10.168 14.101 9.87197 13.7901L5.54397 9.36377H3.27197L8.73597 14.952C9.34397 15.5656 10.144 15.9092 11 15.9092Z"
                        fill={fill}
                    />
                    <path d="M19 18.3638H3V20.0001H19V18.3638Z" fill={fill} />
                </g>
                <defs>
                    <clipPath id="clip0_3375_9880">
                        <rect width="16" height="18" fill="white" transform="translate(3 2)" />
                    </clipPath>
                </defs>
            </svg>
        </SIconSpan>
    )
}

export default DownloadIcon
